export const LeftIcon = ({ fillColor = "#FFF" }) => {
  return (
      <svg viewBox="0 0 16 16" fill={fillColor} xmlns="http://www.w3.org/2000/svg" 
        id="Arrow-Left-S-Fill--Streamline-Remix-Fill" height={32} width={32} >
          <desc>{"Arrow Left S Fill Streamline Icon: https://streamlinehq.com"}</desc>
          <path d="m5.333333333333333 6 4 -4v8l-4 -4Z" strokeWidth={0.6667} /></svg>
  );
};


